/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/*
 * Using this json only for 18F brand.
 */

const data = {
    bannerImage: '//s3.amazonaws.com/com.offerpop.services.media/images/media/58405c5b8f4d336d7b2d3b08/5cd9900ca43dec000fbc131a.PNG',
    subBannerImage: '//s3.amazonaws.com/com.offerpop.services.media/images/media/58405c5b8f4d336d7b2d3b08/5cc7231a605c4c000d905007.PNG',
    description: 'Enter our sweepstakes by sharing a story on how Mom WOWS you with everything she does.</br> Whether it&#39;s something she taught you, a favorite memory, a challenge she overcame… </br>or her famous mac & cheese recipe&#33; We want to hear your &#35;MomsWhoWOW story&#33;',
    tulipBannerImage: '//s3.amazonaws.com/com.offerpop.services.media/images/media/58405c5b8f4d336d7b2d3b08/5cb898668aff7d000f349b2a.PNG',
    rulesImage: '//s3.amazonaws.com/com.offerpop.services.media/images/media/58405c5b8f4d336d7b2d3b08/5cb9ce578aff7d000e427911.PNG',
    socialImage: [{
        image: '//dnsl4xr6unrmf.cloudfront.net/images/op_icons/social_media_icons/facebook.png',
        title: 'Facebook',
    },
    {
        image: '//dnsl4xr6unrmf.cloudfront.net/images/op_icons/social_media_icons/twitter.png',
        title: 'Twitter',
    },
    {
        image: '//dnsl4xr6unrmf.cloudfront.net/images/op_icons/social_media_icons/pinterest.png',
        title: 'Pinterest',
    },
    {
        image: '//dnsl4xr6unrmf.cloudfront.net/images/op_icons/social_media_icons/email.png',
        title: 'Email',
    },
    {
        image: '//dnsl4xr6unrmf.cloudfront.net/images/op_icons/social_media_icons/copy.png',
        title: 'Copy',
    }],
    purchaseDesc: 'No purchase Necessary to enter or win. Void where prohibited. The 1-800-FLOWERS.COM&reg; &#35;MomsWhoWOW Sweepstakes starts 12:00 am ET on 4/22/19 and ends at 11:59 pm ET on 5/13/19.</br>Open to legal residents of the 50 U.S. and DC, 21 years of age or older.  Sponsor is 800-FLOWERS, INC.',
    officialRulesLink: 'https://app.wyng.com/5caf5f3570ab58040f2c73ab?page=page_6982318125749',
    privacyLink: '/About-Us-Privacy-Policy',
    momsWhowWow: [{
        image: '//cdn.wyng.com/54ac3103ef95a67c1cff8ef2/5cda3b70eddfa60289d1f378.JPEG',
        title: 'MonsWhoWow First Banner',
    },
    {
        image: '//cdn.wyng.com/54ac3103ef95a67c1cff8ef2/5cda3b70eddfa60289d1f378.JPEG',
        title: 'MonsWhoWow Second Banner',
    },
    {
        image: '//cdn.wyng.com/54ac3103ef95a67c1cff8ef2/5cda3b70eddfa60289d1f378.JPEG',
        title: 'MonsWhoWow Third Banner',
    },
    {
        image: '//cdn.wyng.com/54ac3103ef95a67c1cff8ef2/5cda3b70eddfa60289d1f378.JPEG',
        title: 'MonsWhoWow Four Banner',
    },
    {
        image: '//cdn.wyng.com/54ac3103ef95a67c1cff8ef2/5cda3b70eddfa60289d1f378.JPEG',
        title: 'MonsWhoWow Fiv Banner',
    },
    {
        image: '//cdn.wyng.com/54ac3103ef95a67c1cff8ef2/5cda3b70eddfa60289d1f378.JPEG',
        title: 'MonsWhoWow Six Banner',
    }],
};

export default data;
